/** Decimal strings from the API → numbers for charts and ratios (0 when missing). */
export const num = (v: string | number | null | undefined): number => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** "12.5%" share of a total; "—" when the total is zero. */
export function share(part: number, total: number): string {
  if (!total) return '—';
  return `${((part / total) * 100).toFixed(1)}%`;
}
